<template>
    <div class='login-container mobile' style='padding: 0 !important;'>
        <div class='contract-content-gratitude' style='padding: 0; display: none'>
          <div
              style='padding: 0'
              v-for="(item, index) in contractList"
              :key="index"
          >
            <div class='contract-content-info-gratitude' style='padding: 0 20px 20px 20px;'>
              <div class='contract-title-input' style='margin-bottom: 20px; margin-top: 20px; background-color: white'
                   :style='`font-size: ${18 * zoomList[zoomIndex] / 100}px`'>
                감사 추적 인증서
              </div>

              <div class='contract-title-input' style='margin-bottom: 1px; margin-top: 1px; background-color: #CCCCCC; height: 1px; padding-bottom: 0; padding-top: 0'/>

              <div class='contract-info-title' style='margin-top: 10px'
                   :style='`font-size: ${16 * zoomList[zoomIndex] / 100}px`'>문서 정보</div>
              <div style='display: flex'>
                <div class='contract-info-sub-title mobile-title'
                     :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>문서 이름</div>
                <div class='contract-info-sub-title' v-show='templateSendId > 0'
                     :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{item.e_contract_title}}</div>
              </div>
              <div style='display: flex'>
                <div class='contract-info-sub-title mobile-title'
                     :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>문서 ID</div>
                <div class='contract-info-sub-title' v-show='templateSendId > 0'
                     :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{item.e_id}}</div>
              </div>
              <div style='display: flex'>
                <div class='contract-info-sub-title mobile-title'
                     :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>상태</div>
                <div class='contract-info-sub-title' v-show='templateSendId > 0'
                     :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{item.templateSendStatus | getContractStatus}}</div>
              </div>
              <div style='display: flex'>
                <div class='contract-info-sub-title mobile-title'
                     :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>기준 시간</div>
                <div class='contract-info-sub-title' v-show='templateSendId > 0'
                     :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>(UTC+09:00) 한국 표준시</div>
              </div>
              <div style='display: flex'>
                <div class='contract-info-sub-title mobile-title'
                     :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>페이지수</div>
                <div class='contract-info-sub-title' v-show='templateSendId > 0'
                     :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>1P</div>
              </div>


              <div class='contract-title-input' style='margin-bottom: 1px; margin-top: 15px; background-color: #CCCCCC; height: 1px; padding-bottom: 0; padding-top: 0'/>
              <div class='contract-info-title' style='margin-top: 10px'
                   :style='`font-size: ${16 * zoomList[zoomIndex] / 100}px`'>서명 요청자</div>
              <div style='display: flex'>
                <div class='contract-info-sub-title mobile-title'
                     :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>이름</div>
                <div class='contract-info-sub-title' v-show='templateSendId > 0'
                     :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{item.centerName}}</div>
              </div>

              <div class='contract-title-input' style='margin-bottom: 1px; margin-top: 15px; background-color: #CCCCCC; height: 1px; padding-bottom: 0; padding-top: 0'/>
              <div style='display:flex'>
                <div style='width:50%'>
                  <div class='contract-info-title' style='margin-top: 10px;'
                       :style='`font-size: ${16 * zoomList[zoomIndex] / 100}px`'>서명 참여자</div>
                  <div style='display: flex'>
                    <div class='contract-info-sub-title mobile-title' style='width: 100px'
                         :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>이름</div>
                    <div class='contract-info-sub-title' v-show='templateSendId > 0'
                         :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{item.recipientName}}</div>
                  </div>
                  <div style='display: flex'>
                    <div class='contract-info-sub-title mobile-title' style='width: 100px'
                         :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>연락처</div>
                    <div class='contract-info-sub-title' v-show='templateSendId > 0'
                         :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{item.recipientPhone | phoneNumberFilter}}</div>
                  </div>
                  <div style='display: flex'>
                    <div class='contract-info-sub-title mobile-title'  style='width: 100px'
                         :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>상태</div>
                    <div class='contract-info-sub-title' v-show='templateSendId > 0'
                         :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{item.templateSendStatus | getContractStatus}}</div>
                  </div>
                </div>
                <div style='width:50%'>
                  <div class='contract-info-title'  style='margin-top: 10px;'
                       :style='`font-size: ${16 * zoomList[zoomIndex] / 100}px`'>서명</div>
                  <div style='display: flex; align-items: center; margin-top: 8px'>
                    <img class='contract-info-signature mobile-sign' v-show='recipientSignImageRawData != ""' :class='recipientSignImageRawData == "" ? "no-image" : ""' :src='`${recipientSignImageRawData}`' />
                  </div>
                </div>
              </div>

              <div class='contract-title-input' style='margin-bottom: 1px; margin-top: 15px; background-color: #CCCCCC; height: 1px; padding-bottom: 0; padding-top: 0'/>
              <div class='contract-info-title' style='margin-top: 10px'
                   :style='`font-size: ${16 * zoomList[zoomIndex] / 100}px`'>진행 이력</div>
              <div
                  style='padding: 0'
                  v-for="(log, idx) in item.templateLog"
                  :key="idx"
              >
                <div style='display: flex'>
                  <div class='contract-info-sub-title mobile-title' style='width: 30%'
                       :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{log.createdAt | timestampFilter2}}</div>
                  <div class='contract-info-sub-title' v-show='templateSendId > 0' style='width: 30%'
                       :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{log.regName}}</div>
                  <div class='contract-info-sub-title' v-show='templateSendId > 0' style='color: blue; width: 40%'
                       :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{log.status | getContractStatus}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>




        <div class='contract-content' style='padding: 0'>
            <div
                    style='padding: 0'
                    v-for="(item, index) in contractList"
                    :key="index"
                >
                <div style='display: flex; align-items: center; padding: 30px 20px 0 20px;'>
                    <div class='contract-info-title' style='margin-top: 0; flex: 1'>{{item.centerName}}</div>
                    <div style='padding: 0 10px' @click='onZoomMinus'>
                        <img style='width: 16px' src='/img/icons/ic_sales_minus.png' />
                    </div>
                    <div style='margin-top: -2px'>{{zoomList[zoomIndex]}}%</div>
                    <div style='padding: 0 10px' @click='onZoomPlus'>
                        <img style='width: 16px' src='/img/icons/ic_sales_plus.png' />
                    </div>
                    <div style='padding: 0 0 0 15px' @click='onMore'>
                      <img style='height: 16px' src='/img/icons/icon_more.png' />
                    </div>
                </div>
                <div class='contract-content-info' style='padding: 0 20px 20px 20px;'>
                        <div class='contract-title-input' style='margin-bottom: 20px; margin-top: 20px; background-color: white'
                             :style='`font-size: ${16 * zoomList[zoomIndex] / 100}px`'>
                            {{item.e_contract_title}}
                        </div>
                        <div class='contract-info-title'
                             :style='`font-size: ${16 * zoomList[zoomIndex] / 100}px`'>서명정보</div>
                        <div style='display: flex'>
                            <div class='contract-info-sub-title mobile-title'
                                 :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>이름</div>
                            <div class='contract-info-sub-title' v-show='templateSendId > 0'
                                 :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{item.recipientName}}</div>
                        </div>
                        <div style='display: flex'>
                            <div class='contract-info-sub-title mobile-title'
                                 :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>연락처</div>
                            <div class='contract-info-sub-title' v-show='templateSendId > 0'
                                 :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{item.recipientPhone | phoneNumberFilter}}</div>
                        </div>
                        <div v-show='item.ticketInfo !== undefined'>
                            <div class='contract-info-title' v-show='item.e_contract_member_type === "M"'
                             :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>이용권 정보</div>
                            <div v-show='templateSendId > 0 && item.e_contract_member_type === "M"'>
                                <div v-for='(ticketInfo, index) in JSON.parse(item.ticketInfo)' :key='index' class='ticket-container'>
                                    <div class='ticket-box' :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>
                                        <div class='ticket-box-title'>{{ticketInfo.title}}</div>
                                        <div class='ticket-box-info'>
                                            <div style='flex: 1'>
                                                {{ticketInfo.period}}
                                            </div>
                                            <div>
                                                {{ticketInfo.price}}원
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class='contract-info-title'
                             :style='`font-size: ${16 * zoomList[zoomIndex] / 100}px`'>약관</div>
                        <div style='padding: 10px 10px 0 10px' v-for='(it, i) in item.templateInfo'>
                            <div v-if='it.type == 1'>
                                <div class='contract-info-sub-title' style='display: flex'>
                                    <div style='flex: 1; word-break: break-all'
                                         :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{it.title}}</div>
                                </div>
                                <textarea class='contract-info-sub-title area' style='resize: none; background-color: transparent; color: #333333; opacity: 1' disabled
                                          :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{it.content}}</textarea>
                            </div>
                            <div v-else style='display: flex'>
<!--                                <div class='com-check' style='margin-top: 12px'>-->
<!--                                    <input-->
<!--                                        :id='`agree-check-${index}-${i}`'-->
<!--                                        name='check-c1'-->
<!--                                        v-model='it.checked'-->
<!--                                        type='checkbox'-->
<!--                                        @change='onCheckOption'-->
<!--                                        :disabled='item.templateSendStatus != "S"'-->
<!--                                    />-->
<!--                                    <label :for='`agree-check-${index}-${i}`' class='agree-option'></label>-->
<!--                                </div>-->
                                <div style='flex: 1;'>
                                    <div class='contract-info-sub-title' style='display: flex'>
                                        <div style='flex: 1;'
                                             :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{it.title}}</div>
                                    </div>
                                    <textarea class='contract-info-sub-title area' style='resize: none; background-color: transparent; color: #333333; opacity: 1' disabled
                                              :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{it.content}}</textarea>
                                    <div v-for='(jt, j) in it.options' style='display: flex; align-items: center; margin-top: 10px'>
                                        <div class='com-check'>
                                            <input
                                                :id='`agree-check-${index}-${i}-${j}`'
                                                v-model='jt.checked'
                                                name='check-c1'
                                                type='checkbox'
                                                @change='onCheckOption'
                                                style='border-bottom-color: #555 !important; border-left-color: #555 !important; border-right-color: #555 !important; border-top-color: #555 !important; color: #555 !important;'
                                                :disabled='item.templateSendStatus != "S"'
                                            />
                                            <label :for='`agree-check-${index}-${i}-${j}`' class='agree-option border-red'><div v-show='it.requiredFlag' class='check-required'>*</div></label>
                                        </div>
                                        <div class='agree-option-input'
                                             :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>{{jt.title}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class='contract-info-title' style='flex: 1;' v-show='templateSendId > 0'
                              :style='`font-size: ${16 * zoomList[zoomIndex] / 100}px`'>{{item.sendTime | dateFormatFilter2}}</div>
                        <div style='display: flex' v-show='templateSendId > 0'>
                            <div class='' style='flex: 1;'
                                 :style='`font-size: ${16 * zoomList[zoomIndex] / 100}px`'></div>
                            <div style='width: 260px; margin-top: 10px'>
                                <div style='display: flex; align-items: center'>
                                    <div class='contract-info-person'
                                         :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>수신인 {{item.recipientName ? (": " + item.recipientName) : ""}}</div>
                                    <div class='contract-info-signature no-image' v-show='recipientSignImageRawData == ""' :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px; width: 80px; height:56px !important; line-height:56px !important`'>(서명)</div>
                                    <img class='contract-info-signature mobile-sign' v-show='recipientSignImageRawData != ""' :class='recipientSignImageRawData == "" ? "no-image" : ""' :src='`${recipientSignImageRawData}`' />
                                </div>
                                <div style='display: flex; align-items: center; margin-top: 10px;'>
                                    <div class='contract-info-person'
                                         :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px`'>발신인 {{item.centerName ? (": " + item.centerName) : ""}}</div>
                                    <div class='contract-info-signature no-image' v-show='senderSignImageRawData == ""' :style='`font-size: ${14 * zoomList[zoomIndex] / 100}px; width: 80px; height:56px !important; line-height:56px !important`'>(서명)</div>
                                    <img class='contract-info-signature mobile-sign' v-show='senderSignImageRawData != ""' :class='senderSignImageRawData == "" ? "no-image" : ""' :src='`${senderSignImageRawData}`' />
                                </div>
                            </div>
                        </div>
                    </div>
                <div v-if='item.templateSendStatus != "S"' style='width: 100%; height: 48px; line-height: 48px; font-size: 16px; text-align: center' :style='`background-color: ${item.templateSendStatus === "N" ? "#ffece9" : "#f4f4f4"}; color: ${item.templateSendStatus === "N" ? "#ff0000" : "#5e5e5e"};`'>
                    {{item.templateSendStatus | getContractSendStatusStr}}
                </div>
                <div v-else style='display: flex; margin-top: 20px; padding: 0 20px 20px 20px;'>
                    <button class='com-btn btn-mobile-login' style='border: 1px solid #ced4da; background-color: transparent !important; color: #7e7777; ' @click='onClickReject'>거절하기</button>
                    <button class='com-btn btn-mobile-login' style='margin-left: auto' @click='onClickSign'>서명하기</button>
                </div>
            </div>
        </div>

        <div v-show="signaturePop" class="layer-pop square">
            <div class="view-content" style='width: 370px; padding: 0 !important;'>
                <div class="com-scroll-y confirm-dlg-box" style='padding-bottom: 10px !important;'>
                    <div style='display: flex; margin-bottom: 5px;'>
                        <div style='flex: 1; font-size: 14px; color: black'>서명을 입력해주세요</div>
                        <div style='font-size: 14px; color: #aaaaaa' @click="onReInput">다시입력</div>
                    </div>
                    <canvas class='signature-container mobile-signature' id='canvas_signature_pad' height='200'></canvas>
                </div>
                <div style='display: flex'>
                    <button class="mobile-dlg-btn" @click="handleCancelSignature">취소</button>
                    <button class="mobile-dlg-btn active" @click="handleConfirmSignature">입력완료</button>
                </div>
            </div>
        </div>

      <div v-show="sendEmailPop" class="layer-pop square">
        <div class="view-content" style='width: 370px; padding: 0 !important;'>
          <div class="com-scroll-y confirm-dlg-box" style='padding-bottom: 10px !important;'>
            <div style='margin-bottom: 5px;'>
              <div style='flex: 1; font-size: 18px; color: #00a4e8; font-weight: bold'>이메일을 입력해 주세요.</div>
              <div style='flex: 1; font-size: 18px; color: #333333; margin-top: 5px; margin-bottom: 5px'>계약 완료한 문서를 전송할<br />이메일을 입력해 주세요.</div>
            </div>
            <input v-model.trim='sendEmail'
                   autofocus
                   placeholder='이메일을 입력해 주세요.'
                   type='email'
                   style='margin-top: 10px; margin-bottom: 15px; font-size: 18px; padding: 10px; width: 100%; border: 1px solid #ced4da; border-radius: 4px'
            />
          </div>
          <div style='display: flex'>
            <button class="mobile-dlg-btn" @click="handleCancelSendEmail">취소</button>
            <button class="mobile-dlg-btn active" @click="handleConfirmSendEmail">확인</button>
          </div>
        </div>
      </div>

        <div v-show="morePop" class="layer-pop square" @click='morePop = false'>
          <div class="view-content small-padding mobile-bottom-dlg">
            <div class='action-sheet-item' @click='onPDFDownload'>PDF 다운로드</div>
            <div class='action-sheet-item' @click='onSendMail'>이메일 전송</div>
            <div class='action-sheet-item'>취소</div>
          </div>
        </div>
      <loading-spinner v-if="isLoading" style='z-index: 5000; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5)'></loading-spinner>
        <confirm-dlg
            v-if="confirmPop"
            :show='confirmPop'
            :title='rejectConfirmTitle'
            :content='rejectConfirmContent'
            :onCancel="handleCancel"
            :onConfirm="handleConfirm"
        ></confirm-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { convertImgToDataURLviaCanvas } from '@/assets/js/common';
import ConfirmDlg from '../../../components/ConfirmDlg';
import SignaturePad from 'signature_pad'
import { Utils } from '@/assets/js/utils';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
    name: 'CheckContract',
    props: {},
    computed: {
    },
    components: {
      LoadingSpinner,
        ConfirmDlg,
    },
    data() {
        return {
            templateSendId: this.$route.params.id,
            contractList: [],
            recipientSignImageRawData: "",
            zoomList: [25, 50, 70, 100, 120, 150],
            zoomIndex: 3,

            confirmPop: false,
            rejectConfirmTitle: "계약서 서명을 거절하시겠습니까?",
            rejectConfirmContent: "서명 거절 시 이 계약서에 서명할 수 없습니다.",
            signEnable: false,

            signaturePop: false,
            signaturePad: null,
            uploadFiles: [], // base64, mimetype, name이 담김. 실제로 서버로 request할 data
            base64data: "",
            senderSignImageRawData: "",

            morePop: false,
            pdfFiles:[],
            pdfFile1 : null,
            pdfFile2 : null,
            uploadEmailFiles:[],
            sendEmailPop: false,
            sendEmail: "",
            isLoading:false,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.setSignaturePad();
            Promise.all([
                this.getTemplate(),
            ]).then((response) => {
                if (response && response.length > 0) {
                    this.contractList = response[0].data;
                    console.log(this.contractList);
                    if (this.contractList && this.contractList.length > 0) {
                        this.contractList.map(item => {
                            if (item.senderSignImageUrl !== "") {
                                this.senderSignImageRawData = item.senderSignImageUrl;
                                convertImgToDataURLviaCanvas(item.senderSignImageUrl, (imageRawData) => {
                                    this.senderSignImageRawData = imageRawData;
                                })
                            }
                            if (item.recipientSignImageUrl !== "") {
                                this.recipientSignImageRawData = item.recipientSignImageUrl;
                                convertImgToDataURLviaCanvas(item.recipientSignImageUrl, (imageRawData) => {
                                    this.recipientSignImageRawData = imageRawData;
                                })
                            }
                        })
                    }

                    this.onCheckOption();

                    this.autoHeightTextArea();
                }
            })
        },

        onZoomPlus() {
            if (this.zoomIndex < 5) {
                this.zoomIndex++;
                this.autoHeightTextArea();
            }
        },

        onZoomMinus() {
            if (this.zoomIndex > 0) {
                this.zoomIndex--;
                this.autoHeightTextArea();
            }
        },

        onMore() {
          this.morePop = true;
        },

        handleCancel() {
            this.confirmPop = false
        },

        async handleConfirm() {
            const { data } = await api.post(`/admin/api/center/0/staff/0/reject/contract/${this.templateSendId}`);

            if (data) {
                // alert("서명이 취소되었습니다.")
                this.confirmPop = false;
                // this.init();
                this.$router.push({
                  path: `/mobile/user/contract/result/${this.templateSendId}`
                });
            }
        },

        handleCancelSignature() {
            this.signaturePad.clear();
            this.signaturePop = false
            this.base64data = ""
        },

        async handleConfirmSignature() {
          if (this.base64data === "") {
            alert("서명을 입력해 주세요.");
            return;
          }
            this.signaturePad.clear();

            this.recipientSignImageRawData = this.base64data;

            let checkState = [];
            this.contractList.map(contract => {
                if (contract.templateInfo && contract.templateInfo.length > 0) {
                    contract.templateInfo.map(info => {
                        if (info.type == 2 && info.options && info.options.length > 0) {
                            info.options.map(it => {
                                checkState.push({
                                    id: it.id,
                                    checked: it.checked
                                })
                            })
                        }
                    })
                }
            })
            const { data } = await api.post(`/admin/api/center/0/staff/0/contract/set/recipient/image`, {
                contractTemplateId: this.templateSendId,
                uploadFiles: this.uploadFiles,
                checkState: checkState
            });

            if (data) {
                this.signaturePop = false;
                // this.init();
                this.$router.push({
                  path: `/mobile/user/contract/result/${this.templateSendId}`
                });
            }
        },

        onReInput() {
            this.signaturePad.clear();
            this.base64data = "";
            this.uploadFiles = [];
        },

        autoHeightTextArea() {
            setTimeout(() => {
                let areas = document.querySelectorAll("textarea");
                for (var i = 0; i < areas.length; i++) {
                    areas.item(i).style.height = "auto"
                    areas.item(i).style.height = areas.item(i).scrollHeight + "px"
                }
            }, 10)
        },

        onCheckOption() {
            let flag = true;
            this.contractList.map(item => {
                if (item.templateInfo) {
                    item.templateInfo.map(it => {
                        if (it.type == 2 && it.requiredFlag) {
                            // if (!it.checked) flag = false;
                            if (it.options) {
                                let checkCount = 0;
                                it.options.map(jt => {
                                    if (jt.checked) checkCount ++;
                                })
                                if (checkCount === 0 && it.options.length > 0) {
                                  flag = false;
                                }
                            }
                        }
                    })
                }
            })

            this.signEnable = flag;
        },

        onPDFDownload() {
          setTimeout(() => {
            let element = document.createElement("div");
            element.style.padding = "20px";

            let contract = document.querySelector(".contract-content-info");

            let html = contract.innerHTML.toString().replace(new RegExp("textarea", 'g'), "div");
            html = html.toString().replace(new RegExp("\n", 'g'), "<br>");
            element.innerHTML = html;
            let filename = this.contractList[0].e_contract_title + '.pdf';
            let opt = {
              filename: this.contractList[0].e_contract_title + '.pdf',
              enableLinks: true,
              image: { type: 'jpeg', quality: 0.98 },
              pagebreak: { mode: 'avoid-all' },
              html2canvas: {
                scale: 3,
                y: 0,
                scrollY: 0,
                useCORS: true,
                width: 800,
                // height: 1130,
                letterRendering: true,
                allowTaint: false, //useCORS를 true로 설정 시 반드시 allowTaint를 false처리 해주어야함
              },
              jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            }

            html2pdf().from(element).set(opt).toPdf()
            .get('pdf')
            .then(function (pdf) {
              console.log("pdf생성테스트");
              const blob = pdf.output('blob');
              if (blob instanceof Blob) {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
              }
              // this.close()
            })
            .catch(function(error) {
              console.error("PDF 생성 중 오류 발생:", error);
            });

          }, 1);
        },

        onSendMail() {
          // 감사추적 pdf파일 생성 및 업로드
          // 전자계약서 pdf파일 생성 및 업로드
          if (this.uploadEmailFiles.length === 0) {
            this.onPDFUpload(0);
            this.onPDFUpload(1);
          }

          this.sendEmailPop = true;
        },
        getTemplate() {
            return api.get(`/admin/api/center/0/staff/0/contract/template/send/${this.templateSendId}`);
        },
      postUploadEmailFiles() {
        return api.post(`/admin/api/center/0/staff/0/contract/send/email/upload`, {
          uploadFiles: this.uploadEmailFiles,
        });
      },

        checkTicketInfo(info) {
            if (info) {
                const ticketInfo = JSON.parse(info);

                return ticketInfo && ticketInfo.length > 0
            }

            return false;
        },

        async onClickReject() {
            this.confirmPop = true;
        },

        onClickSign() {
            if (!this.signEnable) {    // 수신자 sign image가 있는가 확인하고 있는 경우에는 모두 agree항목을 모두 check했는가 확인
              alert("동의 여부 체크 후 서명 해 주세요.")
              return;
            }
            this.signaturePop = true
        },

        async setUploadFile(file) {
            let base64data = await this.readFileAsync(file);
            this.base64data = base64data; // 이미지 미리보기
            base64data = base64data.split(',')[1];
            if (base64data === undefined) {
                alert('빈 파일은 첨부할 수 없습니다.');
                return;
            }
            const fileInfo = {
                filename: file.name,
                mimetype: file.type,
                base64data: base64data,
                type: 2,
            };

            this.uploadFiles = [fileInfo];
        },

        setSignaturePad() {
            const canvas = document.querySelector("#canvas_signature_pad");
            this.signaturePad = new SignaturePad(canvas);

            this.signaturePad.addEventListener("endStroke", () => {
                const file = Utils.getFileFromRawImageData(this.signaturePad.toDataURL());
                this.setUploadFile(file);
            }, { once: false });
        },

        // File reader
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

      onPDFUpload(type) { // type == 0 : 감사추적인증서, type == 1 : 전자계약서
        setTimeout(() => {
          let element = document.createElement("div");
          element.style.padding = "20px";
          let contract = document.querySelector(".contract-content-info");
          if (type === 0) {
            contract = document.querySelector(".contract-content-info-gratitude");
          }

          let html = contract.innerHTML.toString().replace(new RegExp("textarea", 'g'), "div");
          html = html.toString().replace(new RegExp("\n", 'g'), "<br>");
          element.innerHTML = html;
          let filename = this.contractList[0].e_contract_title + '.pdf';
          if (type === 0) {
            filename = '감사추적인증서.pdf';
          }
          let opt = {
            filename: filename,
            enableLinks: true,
            image: { type: 'jpeg', quality: 0.98 },
            pagebreak: { mode: 'avoid-all' },
            html2canvas: {
              scale: 3,
              y: 0,
              scrollY: 0,
              useCORS: true,
              width: 800,
              // height: 1130,
              letterRendering: false,
              allowTaint: false, //useCORS를 true로 설정 시 반드시 allowTaint를 false처리 해주어야함
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          }
          let pdfFile = null;
          html2pdf().from(element).set(opt).toPdf()
            .get('pdf')
            .then(pdf => {
              console.log("pdf생성테스트2");
              const blob = pdf.output('blob');
              if (blob instanceof Blob) {
                console.log(blob)
                // Blob 데이터를 파일 객체로 변환
                pdfFile = new File([blob], filename, {type: 'application/pdf'});
                setTimeout(() => {
                  this.pdfFile1 = pdfFile;
                  this.setUploadEmailFile(pdfFile);
                }, 1000)
              }
              // this.close()
          }).catch(function(error) {
            console.error("PDF 생성 중 오류 발생2222:", error);
          });
        }, 1);
      },
      async setUploadEmailFile(file) {
          if (file !== null) {
            let base64data = await this.readFileAsync(file);
            base64data = base64data.split(',')[1];
            const fileInfo = {
              filename: file.name,
              mimetype: file.type,
              base64data: base64data,
              type: 1,
            };
            console.log(fileInfo);
            this.uploadEmailFiles.push(fileInfo);
          }
      },
      handleCancelSendEmail() {
        this.sendEmailPop = false
        this.sendEmail = ""
        this.isLoading = false
      },

      async handleConfirmSendEmail() {
        // 이메일 체크
        if (this.validateEmail()) {
          this.isLoading = true
          console.log("pdf 파일 갯수 = " + this.pdfFiles.length)
          if (this.pdfFiles.length > 0) {
            await this.setUploadEmailFile(this.pdfFiles[0])
          }

          const date = new Date(this.contractList[0].sendTime);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

          let content = `<div>안녕하세요, 핏투데이케어입니다.</div>

<div>${this.contractList[0].recipientName}님이 ${this.contractList[0].centerName}과 ${formattedDate}일에 계약하신 계약서가 도착했습니다.</div>

<div>문서 내용을 확인해 보세요.</div>
<div></div>

<div>서명 요청자: ${this.contractList[0].centerName}</div>

<div>서명자: ${this.contractList[0].recipientName}</div>

<div>서명 완료시간: ${formattedDate}</div>
<div></div>

<div>· 이 메일의 링크를 공유하지 마십시오.</div>
<div>· 계약 만료일 전까지 이 메일 계정을 삭제하지 마십시오.</div>
<div></div>
<div>감사합니다.</div>
<div>핏투데이케어 드림</div>`;

          Promise.all([
            this.postUploadEmailFiles(),
          ]).then(async (response) => {
            console.log("file upload = " + response[0].data);
            if (response) {
              const {data} = await api.post(`/admin/api/center/0/staff/0/contract/send/email`, {
                sendEmail: this.sendEmail,
                uploadFiles: this.uploadEmailFiles,
                sendContent: content,
                fileGroupID: response[0].data
              });

              if (data) {
                alert('이메일이 발송되었습니다.');
              }
            }
            this.isLoading = false
            this.sendEmailPop = false
            this.sendEmail = ""
          });
        } else {
          alert('이메일을 정확히 입력해 주세요.');
        }
      },
      validateEmail() {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!this.sendEmail) {
          return false
        } else return emailPattern.test(this.sendEmail);
      }
    },
};
</script>
